import { Directive, HostBinding, Input, OnDestroy, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Directive({
    selector: '[portalSrcBlob], [srcBlob]',
    standalone: false
})
export class SrcBlobDirective implements OnDestroy {
  @Input() set srcBlob(value: Blob) {
    this.cleanup();
    if (value) {
      const reader = new FileReader();
      reader.readAsDataURL(value);
      reader.onload = () => {
        this.src = this.sanitizer.sanitize(SecurityContext.URL, reader.result as string);
      };
    } else {
      this.src = value;
    }
  }

  @HostBinding('attr.src')
  src: SafeUrl;

  private url: string;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnDestroy(): void {
    this.cleanup();
  }

  private cleanup(): void {
    if (this.url) URL.revokeObjectURL(this.url);
  }
}
